import { render } from "./MdAlert.vue?vue&type=template&id=87f5c908&ts=true"
import script from "./MdAlert.vue?vue&type=script&lang=ts"
export * from "./MdAlert.vue?vue&type=script&lang=ts"

import "./MdAlert.vue?vue&type=style&index=0&id=87f5c908&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__